import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ssoGuard } from '@core/guards/sso.guard';
import { LoginComponent } from '@public/login/login.component';
import { authGuard } from '@core/guards/auth.guard';
import { PageNotFoundComponent } from '@shared/components/page-not-found/page-not-found.component';
import { CallBackComponent } from '@private/test/callback.component';
import { developerGuard } from '@core/guards/developer.guard';
import { TestComponent } from './test/test.component';

const routes: Routes = [
  {
    canActivate: [authGuard],
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Connexion',
    },
  },
  {
    path: 'public',
    loadChildren: () =>
      import('./public/public.module').then((m) => m.PublicModule),
  },
  {
    canActivate: [ssoGuard],
    path: 'private',
    loadChildren: () =>
      import('./private/private.module').then((m) => m.PrivateModule),
  },

  {
    canActivate: [ssoGuard],
    path: 'myspace',
    loadChildren: () =>
      import('./myspace/myspace.module').then((m) => m.MyspaceModule),
  },
  {
    canActivate: [ssoGuard],
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'dev',
    component: TestComponent,
    canActivate: [developerGuard],
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'callback',
    component: CallBackComponent,
  },

  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
